<template>
  <div>
    <v-row class="custom-form-control custom-figma-1 mb-0">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
            cols="12"
            lg="6"
            md="6"
          >
            <v-row>
              <v-col cols="12" lg="6" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="searchPartner"
                  @keyup.enter="searchData"
                  dense
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbyPartner')"
                  filled
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>

          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right"
            cols="12"
            lg="6"
            md="6"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <v-btn
                @click="searchData()"
                :disabled="!$auth.search"
                class="btn btn-top btn-search btn-width-1"
                color="primary"
              >
                <v-icon x-small class="mr-1">fa fa-search</v-icon>
                {{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn @click="openAddPartnerDialog" :disabled="!$auth.manage" class="btn btn-add">
                  {{ $t('btn.common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  @change="searchByFilter"
                  :items="searchByItems"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                  height="40"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  @input="searchByFilter"
                  @click:append="searchByFilter"
                  @keyup.enter="searchByFilter"
                  heigth="40"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :fixed-header="true"
          :footer-props="{ showFirstLastPage: true }"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :height="tableHeight"
          @page-count="pageCount = $event"
          :class="[
            'partnerList-table list-table code-table srm-list-table custom-border-table',
            listData.length > 0 ? '' : 'custom-border-table-not-data',
          ]"
          hide-default-footer
          no-data-text="No matching records found"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.id"
                @click="onClickRow(item)"
                :class="[selectedRow === item.id ? 'selected_row' : '']"
              >
                <td class="col-name">{{ item.prnrNm }}</td>
                <td>{{ item.cnttPrn }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.remark }}</td>
                <td class="text-center">
                  <font :class="viewStatusTextColor(item.stsCd)">{{ viewStatus(item.stsCd) }}</font>
                </td>
                <td class="text-center">{{ item.updDt }}</td>
                <td>{{ item.updUsrId }}</td>
                <td class="text-center">
                  <v-btn small text icon @click="editItem(item)" :disabled="!$auth.manage">
                    <icon-svg :disabled="!$auth.manage" iconName="edit" />
                  </v-btn>
                  <v-btn small text icon @click="deletePartner(item)" :disabled="!$auth.manage">
                    <icon-svg :disabled="!$auth.manage" iconName="delete" />
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }} of
                    {{ totalCnt }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <AddPartnerLayout
        v-if="dialog.type == 'addPartnerLayout'"
        :id="dialog.id"
        ref="addMapLayout"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @search="searchData"
      ></AddPartnerLayout>
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        title="Partner"
      ></versionHistory>
    </div>
    <dialogWindow
      ref="deleteDialog"
      :info="editedItem.name"
      size="max"
      title="Delete Partner"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the partner'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="onDeleteItem(editedItem)"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import AddPartnerLayout from '@/vue-caas/views/partner/PartnerAdd.vue';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import $ from 'jquery';
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import versionHistory from '@/vue-caas/components/DelHistoryWorkflowDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

export default {
  components: {
    dialogWindow,
    AddPartnerLayout,
    SystemProgress,
    versionHistory,
    IconSvg,
  },
  props: {
    items: {
      default: [],
    },
  },

  data() {
    return {
      tableHeight: '',
      isCreated: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      searchBy: 'all',
      searchByTxt: '',
      searchPartner: '',
      headers: [],
      listData: Array,
      editedItem: {},
      stsCdList: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'Confirmed', value: 'C' },
        { text: 'Waiting Confirmation', value: 'W' },
        { text: 'Not Send Email', value: 'N' },
      ],
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Parnter', value: 'prnrNm' },
        { text: 'Contact Person', value: 'cnttPrn' },
        { text: 'Email', value: 'email' },
        { text: 'Remark', value: 'remark' },
      ],
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      customerItem: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }],
      isLoading: true,
      selectedRow: '',
      totalCnt: 0,
      pageEnter: 1,
    };
  },

  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },

  watch: {
    page() {
      this.pageEnter = this.page;
    },
  },

  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    // 2021.9.21 203728 change to select row as Code Table
    onClickRow(item) {
      this.selectedRow = item.id;
    },
    // 2021.04.05 203708 SPKA-63-Issue31
    searchByFilter(str) {
      this.$store.commit('SET_STORE_PARTNER_LIST_FILTER', {
        filter: this.searchBy,
        str: this.searchByTxt,
      });
      this.listData = this.$store.getters.partnerList;
      this.totalCnt = this.listData.length;
      this.caculatePageCount();
    },
    searchData() {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      this.searchBy = 'all';
      this.searchByTxt = '';
      const params = {
        searchPartner: this.searchPartner,
      };
      this.$store
        .dispatch('getPartnerListByCompany', params)
        .then(() => {
          this.isLoading = false;
          this.listData = this.$store.getters.partnerList;
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    initEditedItem() {
      this.editedItem = {
        prnrNm: '',
        cnttPrn: '',
        email: '',
        emailF: '',
        emailT: '',
        stsCd: '',
        remark: '',
      };
    },
    deletePartner(item) {
      this.editedItem = Object.assign({}, item);
      let self = this;
      if (cfg.isDlb) {
        self.$refs.deleteDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', { type: 'Partner', value: item.prnrId })
          .then((res) => {
            if (res.length > 0) {
              self.openVersionHistory(res, item);
            } else {
              self.$refs.deleteDialog.dialog = true;
            }
          });
      }
    },
    onDeleteItem(item) {
      this.$store.dispatch('deletePartner', item).then(() => {
        this.listData = this.$store.getters.partnerList;
      });
    },
    openVersionHistory(versionList, val) {
      let type = 'versionHistory';
      let item = {};
      item.ROWID = 0;
      item.versionList = versionList;
      item.comNm = val.prnrNm;
      item.item = val;
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    editItem(rowItem) {
      let type = 'addPartnerLayout';
      let item = {
        ROWID: 0,
        action: 'modify',
        data: rowItem,
      };
      let indexArrDialog = this.findDialog('addPartnerLayout_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    viewStatus(stsCd) {
      let result = '';
      if (stsCd === 'C') {
        result = 'Confirmed';
      } else if (stsCd === 'W') {
        result = 'Waiting Confirmation';
      } else if (stsCd === 'N') {
        result = 'Not Send Email';
      }
      return result;
    },

    viewStatusTextColor(stsCd) {
      let result = '';
      if (stsCd === 'C') {
        result = 'confirm--text text--lighten-2';
      } else if (stsCd === 'W') {
        result = 'waiting--text text--lighten-2';
      } else if (stsCd === 'N') {
        result = 'notsend--text text--lighten-2';
      }
      return result;
    },
    openAddPartnerDialog() {
      let type = 'addPartnerLayout';
      let item = {
        ROWID: 0,
        action: 'add',
      };
      let indexArrDialog = this.findDialog('addPartnerLayout_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
  },

  created() {
    this.listData = this.items;
    this.headers = [
      { text: 'Name', value: 'prnrNm', align: 'start', width: '280' },
      { text: 'Contact Person', value: 'cnttPrn', align: 'start', width: '200' },
      { text: 'Email', value: 'email', align: 'start', width: '150' },
      { text: 'Remark', value: 'remark', align: 'start', 'min-width': '150' },
      { text: 'Status', value: 'stsCd', align: 'center', width: '240' },
      { text: 'Last Update', value: 'updDt', align: 'center', width: '170' },
      { text: 'Update User', value: 'updUsrId', align: 'left', width: '170' },
      { text: 'Manage', value: 'manage', align: 'center', sortable: false, width: '100' },
    ];

    // 2021.5.18 203728 SPKA-107 get company list
    this.$store.dispatch('getCompanyListSetup').then(() => {
      console.log('--------- Finished to process Company List ----------');
      this.$store.getters.companiesForSetup.map((e) => {
        this.customerItem.push({ text: e.compNm, value: e.compId });
      });
    });

    this.searchData();
    EventBus.$on('delete-item', this.onDeleteItem);
    this.isCreated = true;
  },

  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
    });
  },
};
</script>

<style>
.v-data-table.elevation-1.partnerList-table .v-data-table-header th {
  font-size: 14px !important;
}
.partnerList-table .v-data-table-header th {
  text-align: center !important;
}
.partnerList-table .v-data-table__wrapper {
  overflow-y: auto;
}
.theme--light .partnerList-table {
  background: #ffffff !important;
}
.theme--light .partnerList-table tbody td {
  border-bottom: 1px solid #e0e6f2 !important;
  border-right: 1px solid #e0e6f2 !important;
}
.theme--light .partnerList-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background: #eaf1f8 !important;
}
.theme--dark .partnerList-table {
  background: #292c35 !important;
}
</style>
